import FeatherIcon from 'feather-icons-react';
import React from 'react';

const Button = ({ text,btnClassNames,onClick,svgClassNames,isLoading,loadingText, icon,type }) => {
    return (
        <button disabled={isLoading} className={`disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 ${btnClassNames}`} onClick={onClick} type={type} >
        {
        isLoading ?
         <span className='inline-flex items-center gap-1.5'>
            <FeatherIcon icon="loader" className={`h-4 w-4 animate-spin ${svgClassNames}`} />
         {loadingText}
         </span>
        : icon ?
        <span className='inline-flex items-center gap-1.5'>
            <FeatherIcon icon={icon} className={`h-4 w-4`} />
         {text}
         </span>
          : text
      }
      </button>
    )
}

export default Button;
